export default "/images/4161b3d4b92e7f64604f9bf628cf7fd9.avif";